import React from 'react';
import {Disclosure} from "@headlessui/react";
import FactArticle from "./FactArticle";
import {FactData} from "types/Fact";

type FactListProps = {
  facts: Array<FactData>
  previewCount: number
}

function FactList({facts, previewCount}: FactListProps) {
  const completedFacts = facts.filter(fact => !!fact.value)
  const previewFacts = completedFacts.slice(0, previewCount)
  const remainingFacts = completedFacts.slice(previewCount)

  return (
    <>
      <ul className="mt-8 text-gray-600">
        {previewFacts.map((fact, index) => <FactArticle fact={fact} key={index}/>)}
      </ul>

      {!!remainingFacts.length &&
        <Disclosure>
          {({open}) => (
            <>
              {!open &&
                <Disclosure.Button className="mt-7 text-brand font-medium">
                  <span className="underline">View more</span> &gt;
                </Disclosure.Button>
              }
              <Disclosure.Panel>
                <ul className="mt-8 text-gray-600">
                  {remainingFacts.map((fact, index) => (<FactArticle fact={fact} key={index}/>))}
                </ul>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      }
    </>
  );
}

FactList.defaultProps = {
  previewCount: 3
}

export default FactList;